import { render } from "./PalettenPage.vue?vue&type=template&id=451dbb9c"
import script from "./PalettenPage.vue?vue&type=script&lang=js"
export * from "./PalettenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__